(function ($, window) {
    'use strict';

    $(function () {
        const $header = $('.js-sticky-header');
        const visibleHeight = 400;
        const activeClass = 'is-sticky';
        let isPending = false;

        const handleScroll = () => {
            const currentScrollTop = ($(window).scrollTop() || $('body').scrollTop());

            if (currentScrollTop > visibleHeight) {
                if (!$header.hasClass(activeClass)) {
                    $('body').addClass('sticky-header-active');
                    $header.addClass(activeClass).attr('aria-hidden', 'false');
                }
            } else {
                if ($header.hasClass(activeClass)) {
                    $('body').removeClass('sticky-header-active');
                    $header.removeClass(activeClass).attr('aria-hidden', 'true');
                }
            }

            isPending = false;
        };

        const onScroll = () => {
            if (!isPending) {
                requestAnimationFrame(handleScroll);
                isPending = true;
            }
        };

        $(window).on('scroll', onScroll);
        $(window).trigger('scroll');
    });
})(jQuery, window);
